﻿import EventHandler from './EventHandler';
import ListView from './ListView';
import Cookies from './Cookies';

import { ISearchResult } from './ISearchResult';

/**
 * Kereső
 */

// Create Base64 Object
var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = Base64._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/\r\n/g, "\n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = 0; var c1 = 0; var c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2 } else { c2 = e.charCodeAt(n + 1); var c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3 } } return t } }

class SearchState {
    public formData: JQuery.NameValuePair[];
    public loadedPages: number;

    constructor(formData: JQuery.NameValuePair[], loadedPages: number) {
        this.formData = formData;
        this.loadedPages = loadedPages;
    }

    public serialize(): string {

        var data = {
            formData: this.formData,
            loadedPages: this.loadedPages
        };
        return Base64.encode(JSON.stringify(data));
    }

    public static deserialize(s: string): SearchState {
        var data = JSON.parse(Base64.decode(s));
        return new SearchState(data.formData, data.loadedPages);
    }
}

export default class Search extends EventHandler {
    private _root: HTMLElement;
    private _initialPage: number;
    private _form: HTMLElement;
    private _provinces: HTMLElement;
    private _cities: HTMLElement;
    private _isOpen: boolean;
    private _showResults: boolean;    
    private _listView: ListView;
    private _cookies: Cookies;
    private _moreButton: HTMLElement;

    protected page: number;
    protected formData: JQuery.NameValuePair[];    

    constructor(listView: ListView, cookies: Cookies) {
        super();

        this._root = document.querySelector('.search');
        if (this._root === null)
            return; // nem a keresési oldalon vagyunk

        this._initialPage = $(this._root).data("initial-page");

        this._form = this._root.querySelector('.search form');
        this._provinces = this._root.querySelector('select.search__provinces');
        this._cities = this._root.querySelector('select.search__cities');
        this._listView = listView;        
        this._cookies = cookies;
        this._moreButton = this._root.querySelector("#search-more-button");

        this.bind();
        
        // this.loadCities(); 

        this.performSearch(false);
    }

    private bind() {        

        this._form.addEventListener('submit', (event: Event) => {
            event.preventDefault();

            this.performSearch(false);
            this.showResults();
        });

        this._moreButton.addEventListener('click', (event: Event) => {
            this.performSearch(true);
            this.showResults();
        });

        this._provinces.addEventListener('change', (e) => {
            this.loadCities($(e.target).val().toString());
        });
        
    }

    toggle() {
        this._root.querySelector('#search-toggle-back').classList.add('search__toggler--hidden');
        if (this._isOpen && this._showResults) {
            this.hideResults();
            if (window.innerWidth > 767) { 
                this._root.querySelector('#search-toggle-open').classList.remove('search__toggler--hidden');
                this._root.querySelector('#search-toggle-close').classList.add('search__toggler--hidden');
                this.close();
            }
        }
        else if (this._isOpen) {
            this._root.querySelector('#search-toggle-open').classList.remove('search__toggler--hidden');
            this._root.querySelector('#search-toggle-close').classList.add('search__toggler--hidden');
            this.close();
        }
        else if (!this._isOpen) {
            this._root.querySelector('#search-toggle-open').classList.add('search__toggler--hidden');
            this._root.querySelector('#search-toggle-close').classList.remove('search__toggler--hidden');
            this.open();
            if (window.innerWidth > 767) {
                this.showResults();
            }
        }
    }

    open() {
        this._root.classList.add('search--open');

        if (!this._isOpen) {
            this.trigger('opened');
            this._isOpen = true;
        }
    }

    close() {
        this._root.classList.remove('search--open');

        if (this._isOpen) {
            this.trigger('closed');
            this._isOpen = false;
        }
    }

    showResults() {
        this._root.classList.add('search--show-results');

        if (!this._showResults) {
            this._showResults = true;
        }
    }

    hideResults() {
        this._root.classList.remove('search--show-results');

        if (this._showResults) {
            this._showResults = false;
        }
    }

    performSearchSingleEndpoint(continueSearch: boolean) {
        if (!continueSearch) {
            this.formData = $(this._form).serializeArray();
            if (this._initialPage !== null) { // oldaltöltéskor be van töltve előre x oldal. azokat kihagyjuk, de csak egyetlen alkalommal. utána az initialPage-t null-ra tesszük
                this.page = this._initialPage;
                this._initialPage = null;                
                return;
            } else {
                this.page = 0;
            }
        }

        var data = this.formData.slice(); // copy array
        data.push({ "name": "page", "value": this.page.toString() }); // page

        $.get(
            "/Search/QueryAsGallery",
            data,
            (result) => {
                this._listView.loadResults(result as ISearchResult, continueSearch);
                this.page++;
                if (this.page >= result.numberOfPages) {
                    // vége
                    $(this._moreButton).hide();
                } else {
                    $(this._moreButton).show();
                }

                // kereső állapotának mentése base64 stringbe (mert szimplán cookieba téve a jsont bizonyos esetekben (ékezetek?) elszáll a komplett oldal 400-as hibával)
                var serializedState = new SearchState(this.formData, this.page).serialize();
                this._cookies.setCookie("searchState", serializedState, null);

                // teszt: állapot visszatöltése
                // var state = SearchState.deserialize(serializedState);
                // console.log(state);

            },
            "json"
        );        
    }

    performSearchMultipleEndpoints() {

        let remaining = 2;
        let galleryResult = null;
        let mapResult = null;

        // lejött mindkettő, lehet tölteni az oldalt
        function finish() {
            let result = {
                "results": {
                    "as_gallery": galleryResult,
                    "as_map": mapResult
                }
            };
            this._mapView.loadResults(result as ISearchResult);
            this._listView.loadResults(result as ISearchResult);
        }

        // galéria nézet ajax
        $.ajax({
            url: "/Search/QueryAsGallery",
            type: 'post',
            data: $(this._form).serializeArray(),
            dataType: 'html'
        }).done(result => {
            galleryResult = result;
            if (--remaining == 0)
                finish.call(this);
        });

        // térkép nézet ajax
        $.ajax({
            url: "/Search/QueryAsMap",
            type: 'post',
            data: $(this._form).serializeArray(),
            dataType: 'json'
        }).done(result => {
            mapResult = result.results.as_map;
            if (--remaining == 0)
                finish.call(this);
        });
     
    }

    performSearch(continueSearch: boolean) {
        this.performSearchSingleEndpoint(continueSearch);
    } 

    isPhone() {
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        } else {
            return false;
        }
    }

     loadCities(provinceId?: string) {
        let data: any = {};
        if (typeof provinceId !== "undefined" && provinceId != "")
             data.provinceId = provinceId;
         $.ajax({
             url: "/Search/Cities",
             data: data,
             async: true,
             success: (response) => {
                 $(this._cities).html("");
                 for (let i in response.cities) {
                     if (response.cities[i].hasPlace) {
                         $(this._cities).append('<option value="' + response.cities[i].id + '">' + response.cities[i].name + '</option>');
                     } else {
                         $(this._cities).append('<option value="' + response.cities[i].id + '" disabled >' + response.cities[i].name + '</option>');
                     }
                     
                 }
                 
                 ($(this._cities) as any).selectpicker("refresh");
                 
             }
         });
         
    }

}